import { ChangeEvent, FormEvent, useState } from 'react';
import { post } from '../api';
import { Link } from 'react-router-dom';
import { z } from 'zod';

const emailSchema = z.string().email('Invalid email address');

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);

    const result = emailSchema.safeParse(email);
    if (!result.success) {
      setError(result.error.issues[0].message);
      return;
    }

    setLoading(true);
    try {
      await post('auth/forgot-password', { email });
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="columns">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <h2 className="title is-4">Check your email</h2>
          <p>
            If an account exists for <strong>{email}</strong>, we've sent a
            password reset link.
          </p>
          <p className="mt-4">
            <Link to="/login">Back to login</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="columns">
      <div className="column is-half is-offset-one-quarter">
        <h2 className="title is-4">Reset your password</h2>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="label">Email</label>
            <input
              className={`input${error ? ' is-danger' : ''}`}
              type="email"
              value={email}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setEmail(e.target.value)
              }
              autoFocus
            />
            {error && <p className="help is-danger">{error}</p>}
          </div>
          <button
            className={`button is-primary${loading ? ' is-loading' : ''}`}
            type="submit"
          >
            Send reset link
          </button>
        </form>
        <p className="mt-4">
          <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
